import { render } from "./IHeader.vue?vue&type=template&id=5434f4ad"
import script from "./IHeader.vue?vue&type=script&lang=js"
export * from "./IHeader.vue?vue&type=script&lang=js"

import "./IHeader.vue?vue&type=style&index=0&id=5434f4ad&lang=sass"

import exportComponent from "/Users/ilya/Documents/Web/github/iTunes-Vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__